import { Shimmer } from '@components';

import {
  Container,
  Content,
  Header,
  Title,
  Heading,
  Spacing,
  Buttons,
} from './Onboarding.styles';

const TableContentLoading = () => {
  return (
    <Content>
      <Spacing>
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4, marginTop: 8 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
        <Shimmer
          style={{ height: 40, width: '100%', borderRadius: 4, marginTop: 8 }}
          primary="#f1f1f1"
          secondary="#ececec"
        />
      </Spacing>
    </Content>
  );
};

const TableLoading = () => {
  return (
    <>
      <Spacing>
        <Heading>
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <div />
        </Heading>
      </Spacing>

      <TableContentLoading />
    </>
  );
};

const OnboardingLoading = () => {
  return (
    <Container>
      <Header>
        <Title>Onboarding</Title>
        <Buttons>
          <Shimmer
            style={{ height: 36, width: 250, borderRadius: 8, marginRight: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 36, width: 136, borderRadius: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </Buttons>
      </Header>

      <TableLoading />
    </Container>
  );
};

const OnboardingNewFileLoading = () => {
  return (
    <Container>
      <Header>
        <Title>
          <Shimmer
            style={{ height: 16, width: 136, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />

          <Shimmer
            style={{ height: 12, width: 260, borderRadius: 4, marginTop: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />

          <Shimmer
            style={{ height: 10, width: 60, borderRadius: 4, marginTop: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </Title>

        <Buttons>
          <Shimmer
            style={{ height: 36, width: 250, borderRadius: 8, marginRight: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 36, width: 136, borderRadius: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </Buttons>
      </Header>

      <TableLoading />
    </Container>
  );
};

const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 18, width: 18, borderRadius: 4, marginLeft: 12 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export {
  OnboardingLoading,
  TableLoading,
  TableContentLoading,
  OnboardingNewFileLoading,
  CountLoading,
};
